import {http} from "../http";

export interface YGB{
    gbNo:string;
    iban:string;
}
export interface Avans{
    pinCode:string;
    iban:string;
}
export interface ConvertData {
    toConvert: string,
    transferAmount : number,
    amountCurrency: [
        {
            currency: string,
            amount: number
        }
    ]
}
export const GetInfByGBNO = async (request_data: YGB): Promise<any> => {
    const { data } = await http.post<YGB>("brdgk/getInfoByGbNo", request_data);
    return data;
};
export const GetInfByPinCode = async (request_data: Avans): Promise<any> => {
    const { data } = await http.post<Avans>("brdgk/getAdvance", request_data);
    return data;
};
export const ConvertBulk = async (request_data: ConvertData): Promise<any> => {
    const { data } = await http.post<ConvertData>("brdgk/convert-bulk", request_data);
    return data;
};
export const GetCustomerCountries = async () => {
    const { data } = await http.get(`brdgk/countries`);
    return data;
};
export const GetCustomerCurrencies = async () => {
    const { data } = await http.get(`brdgk/currencies`);
    return data;
};